// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TcB5T","logo":"styles_logo__8C7c4","text-routes":"styles_text-routes__nvxHx","toggle-container":"styles_toggle-container__YpeMo"};